export default {"src":"/_next/static/media/placeholder-coach.cdf160ab.svg","height":1044,"width":1044,"blurWidth":0,"blurHeight":0};